import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { FeatureFlag } from '@app/enums';
import { DeductionType } from '@app/models/payroll/deduction-type.model';
import { FeatureService } from '@app/services/feature.service';

@Component({
    selector: 'app-deduction-taxation',
    templateUrl: './deduction-taxation.template.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeductionTaxationComponent implements OnInit {
    @Input() deductionType?: DeductionType;

    qcPayrollFeatureFlag = false;

    constructor(private features: FeatureService) {}

    ngOnInit(): void {
        this.features.has(FeatureFlag.qcPayroll).then((qcPayrollFeatureFlag) => {
            this.qcPayrollFeatureFlag = qcPayrollFeatureFlag;
        });
    }
}
